// export const API_DEV = 'http://localhost:3000';
// export const API_DEV = 'https://dev-clb-api.04h11.com/';
// export const API_DEV = 'https://clb-api.04h11.com/';

// export const API_WEATHER = 'https://api.darksky.net/forecast/f5401dbc55c1acda5dd975fcc1d9a14c'

var env = process.env.REACT_APP_STAGE || "local";
var configs = (window.Configs || {})[env] || {};

export const API_DEV = configs.API || "/";
export const API_WEATHER = configs.WEATHER || "/";
export const WS_NOTIF = configs.WS || "/";
